import React from "react";
import { CATEGORY_COLORS, PRIORITY_COLOR } from "./mockTasks";

const MAX_VISIBLE_ROLES = 2;

/**
 * Flat task card that fills the entire table cell.
 * Styled to exactly match the reference image:
 *   - 4px left border (category colour)
 *   - Subtle background tint (category colour)
 *   - Title (bold, blue link style) + priority text right-aligned
 *   - Status (small, gray)
 *   - Roles with pipe separator + "+N" overflow count
 *   - Team members as comma-separated text
 */
const TaskCard = ({ task, isEmployee }) => {
  const cat    = CATEGORY_COLORS[task.category] || { border: "#94a3b8", bg: "#f8fafc" };
  const pColor = PRIORITY_COLOR[task.priority]  || "#94a3b8";

  const visibleRoles = task.roles.slice(0, MAX_VISIBLE_ROLES);
  const extraRoles   = task.roles.length - MAX_VISIBLE_ROLES;
  const teamText     = task.team.join(", ");

  return (
    <div
      style={{
        borderLeft: `4px solid ${cat.border}`,
        background: cat.bg,
        padding: "10px 14px",
        height: "100%",
        minHeight: 90,
        boxSizing: "border-box",
      }}
    >
      {/* ── Row 1: title (+ priority for non-employee) ── */}
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 8,
          marginBottom: 4,
        }}
      >
        <span
          style={{
            fontSize: 13,
            fontWeight: 700,
            color: "#3b82f6",
            lineHeight: 1.3,
            cursor: "pointer",
          }}
        >
          {task.title}
        </span>
        {!isEmployee && (
          <span
            style={{
              fontSize: 10,
              fontWeight: 700,
              color: pColor,
              whiteSpace: "nowrap",
              flexShrink: 0,
              letterSpacing: "0.04em",
              textTransform: "uppercase",
            }}
          >
            {task.priority} Priority
          </span>
        )}
      </div>

      {/* ── Row 2: status / task ── */}
      <div style={{ fontSize: 11, color: "#64748b", marginBottom: isEmployee ? 0 : 6 }}>
        {task.status}
      </div>

      {/* ── Rows 3 & 4: only for non-employee ── */}
      {!isEmployee && (
        <>
          {/* Roles */}
          <div
            style={{
              fontSize: 11,
              color: "#475569",
              marginBottom: 5,
              display: "flex",
              flexWrap: "nowrap",
              alignItems: "center",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            {visibleRoles.map((role, i) => (
              <span key={i}>
                {i > 0 && <span style={{ color: "#94a3b8", margin: "0 4px" }}>|</span>}
                <span style={{ overflow: "hidden", textOverflow: "ellipsis", maxWidth: 110, display: "inline-block", verticalAlign: "bottom" }}>
                  {role}
                </span>
              </span>
            ))}
            {extraRoles > 0 && (
              <span style={{ color: "#64748b", fontWeight: 600, marginLeft: 4, whiteSpace: "nowrap" }}
                title={task.roles.slice(MAX_VISIBLE_ROLES).join(", ")}>
                +{extraRoles}
              </span>
            )}
          </div>

          {/* Team members */}
          <div style={{ fontSize: 11, color: "#475569", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {teamText}
          </div>
        </>
      )}
    </div>
  );
};

export default TaskCard;